<template>
  <d-container fluid class="main-content-container px-4 product-form">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Stany materiałów</span>
        <h3 class="page-title">
          Edycja materiałów i kolorów
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/stany-materialow/materialy-i-kolory')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>

            <validation-observer
              ref="colors-form"
              tag="form">
              <div v-if="allDataLoaded">
                <div class="form-group">
                  <label for="name">
                    Nazwa produktu:
                  </label>

                  <strong class="text-primary">
                    {{ data.name }}
                  </strong>
                </div>

                <div class="form-group w-25">
                  <label for="code">
                    Powierzchnia belki:
                  </label>

                  <validation-provider
                    rules="required|min_value:0|only-numbers"
                    name="name"
                    v-slot="{ errors }">
                    <d-input-group
                      append="cm2"
                      :state="errors.length ? 'invalid' : null">
                      <d-input
                        type="text"
                        class="text-right"
                        :state="errors.length ? 'invalid' : null"
                        @change="updateColors"
                        v-model="data.bolt_surface" />
                    </d-input-group>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Kolor</th>
                        <th>Stan belki</th>
                        <th>Stan w cm<sup>2</sup></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="!data.colors.length">
                        <td colspan="3">
                          <d-alert
                            theme="light"
                            class="text-center">
                            Brak kolorów dla tego materiału...
                          </d-alert>
                        </td>
                      </tr>
                      <tr
                        v-for="(color, index) of data.colors"
                        :key="'color-' + index">
                        <td>
                          {{ color.name }}
                        </td>
                        <td style="width: 200px;">
                          <validation-provider
                            rules="required|min_value:0|only-numbers"
                            name="name"
                            v-slot="{ errors }">
                            <d-input-group
                              append="belki"
                              :state="errors.length ? 'invalid' : null">
                              <d-input
                                type="text"
                                class="text-right"
                                :state="errors.length ? 'invalid' : null"
                                @change="updateCm(index)"
                                v-model="color.stock_bolt" />
                            </d-input-group>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </validation-provider>
                        </td>
                        <td style="width: 200px;">
                          <validation-provider
                            rules="required|min_value:0|only-numbers"
                            name="name"
                            v-slot="{ errors }">
                            <d-input-group
                              append="cm2"
                              :state="errors.length ? 'invalid' : null">
                              <d-input
                                type="text"
                                class="text-right"
                                :state="errors.length ? 'invalid' : null"
                                @change="updateBolt(index)"
                                v-model="color.stock_cm" />
                            </d-input-group>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </validation-provider>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </validation-observer>

            <div
              v-if="!allDataLoaded"
              class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'materials-stock-product-form',
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data() {
    return {
      data: {
        id: '',
        name: '',
        bolt_surface: '',
        colors: []
      },
      loaded: false,
      loadError: false,
    };
  },
  mounted () {
    this.loadItemData();
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/materials-stock/materials/item/',
        instanceFields: ['id', 'name', 'bolt_surface', 'colors'],
        loadedKey: 'loaded'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['colors-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();

      FormUtils.submit(this, {
        endpoint: '/materials-stock/materials/update/' + parseInt(this.data.id, 10),
        formData: formDataToSend,
        successTitle: 'Zapisano stan materiału',
        successText: 'Stan materiału w wybranym został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja stanu materiału nie powiodła się. Spróbuj ponownie...',
        successAction: () => {
          this.loaded = false;
          this.loadItemData();
        }
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        bolt_surface: parseFloat(this.data.bolt_surface),
        colors: []
      };

      for (let i = 0; i < this.data.colors.length; i++) {
        formDataToSend.colors.push({
          id: this.data.colors[i].id,
          stock_bolt: parseFloat(this.data.colors[i].stock_bolt),
          stock_cm: parseFloat(this.data.colors[i].stock_cm)
        });
      }

      return formDataToSend;
    },
    updateColors () {
      let newValue = parseFloat(this.data.bolt_surface);

      // eslint-disable-next-line
      if (!isNaN(newValue)) {
        for (let i = 0; i < this.data.colors.length; i++) {
          this.data.colors[i].stock_bolt = parseFloat(this.data.colors[i].stock_cm / newValue);
        }
      }
    },
    updateCm (index) {
      this.data.colors[index].stock_cm = parseFloat(this.data.colors[index].stock_bolt * this.data.bolt_surface);
    },
    updateBolt (index) {
      this.data.colors[index].stock_bolt = parseFloat(this.data.colors[index].stock_cm / this.data.bolt_surface);
    }
  }
};
</script>
